import { GridWidget, GridWidgetTemplate } from "models/dashboard";

import { WidgetKeys } from "../constants/widgets.constants";

export const getWidgetName = (
  widget: GridWidget | GridWidgetTemplate | string
): string => {
  if (!widget) return "";

  const component = typeof widget === "string" ? widget : widget.component;

  switch (component?.toLowerCase()) {
    case WidgetKeys.MapWidgetKey:
      return "Map";
    case WidgetKeys.XdaWidgetKey:
      return "XDA Viewer";
    case WidgetKeys.ThreeDWidgetKey:
      return "3D Visualizer";
    case WidgetKeys.DataTableWidgetKey:
      return "Data Table";
    case WidgetKeys.ChartWidgetKey:
      return "Chart";
    case WidgetKeys.WellCardWidgetKey:
      return "Well Card";
    case WidgetKeys.TypeLogWidgetKey:
      return "Type Log";
    case WidgetKeys.FacilityTicketWidgetKey:
      return "Facility Ticket";
    case WidgetKeys.InfoWidgetKey:
      return "Well Information";
    case WidgetKeys.XdaViewerWidgetKey:
      return "XDA Viewer";
    case WidgetKeys.SurveyVisWidgetKey:
      return "Survey Visualizer";
    case WidgetKeys.CompletionWidgetKey:
      return "Well Completions";
    case WidgetKeys.SamWidgetKey:
      return "SAM Charts";
    case WidgetKeys.SamTableWidgetKey:
      return "SAM Table";
    case WidgetKeys.ExploitableReportWidgetKey:
      return "Exploitable Report";
    case WidgetKeys.SamRfPvWidgetKey:
      return "SAM RF vs PV";
    case WidgetKeys.MultiphaseChartWidgetKey:
      return "Multiproduct Chart";
    case WidgetKeys.TypeWellEditorWidgetKey:
      return "Type Well Editor";
    case WidgetKeys.TypeWellDetailsWidgetKey:
      return "Type Well Details";
    case WidgetKeys.GeoMapLoaderWidgetKey:
      return "Geo Map Loader";
    case WidgetKeys.MidstreamChartWidgetKey:
      return "Midstream Chart";
    case WidgetKeys.MidstreamDataTableWidgetKey:
      return "Midstream Data Table";
    case WidgetKeys.PadScenarioWidgetKey:
      return "Pad Scenario";
    case WidgetKeys.ForecastingWidgetKey:
      return "Forecasting";
    case WidgetKeys.WellDataAnalyzer:
      return "Well Data Analyzer";
    case WidgetKeys.FeatureImportanceWidgetKey:
      return "Machine Learning";
    case WidgetKeys.MidstreamNavigatorWidgetKey:
      return "Network Table";
    case WidgetKeys.AutomationWidgetKey:
      return "Automation";
    case WidgetKeys.GeoMapDataTableWidgetKey:
      return "Geo Map Data Table";
    case WidgetKeys.RigFracChartWidgetKey:
      return "Rig & Frac Chart";
    case WidgetKeys.RigFracDataTableWidgetKey:
      return "Rig & Frac Data Table";
    case WidgetKeys.WellStatusChartWidgetKey:
      return "Well Status Chart";
    default:
      return "";
  }
};
